import { render, staticRenderFns } from "./tablecolumn.vue?vue&type=template&id=7d19e5f0&scoped=true&"
import script from "./tablecolumn.vue?vue&type=script&lang=js&"
export * from "./tablecolumn.vue?vue&type=script&lang=js&"
import style0 from "./tablecolumn.vue?vue&type=style&index=0&id=7d19e5f0&scoped=true&lang=scss&"
import style1 from "./tablecolumn.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d19e5f0",
  null
  
)

export default component.exports